import { useProjectMetadataDefinition, useTranslation } from 'hooks/store';

export function useTranslatedMetadataLabel() {
	const [{ data: projectMetadataDefinition }] = useProjectMetadataDefinition();
	const { translate } = useTranslation();

	return (value: string | number) => {
		const metadataParameter = projectMetadataDefinition?.metadataDefinition?.find(
			param => param.categories && param.categories.some(cat => cat.id === value)
		);

		if (!metadataParameter || !metadataParameter.categories) {
			return '';
		}

		return translate(() => metadataParameter.categories.find(p => p.id === value)?.name ?? '');
	};
}
